export default {
    live: 'En cours',
    over: 'Terminée',
    planned: 'En attente',
};
